import { stringifyQuery } from '#layers/base/public';

/**
 * Fields required to hydrate the authenticated user from the `/me` endpoint.
 *
 * Nested relation key fields are included so RStore can cache the included
 * `orgRole` and `role` objects instead of receiving keyless relation payloads.
 */
export const CURRENT_USER_FIELDS_QUERY = stringifyQuery({
	fields: ['id', 'email', 'fullName', 'avatarId', 'appearance'],
	include: {
		authLinks: { fields: ['providerId'] },
		orgRole: {
			fields: ['userId', 'orgRoleId'],
			include: {
				role: { fields: ['id', 'isAdmin'] },
			},
		},
	},
});
